import axios from "axios";

// const api_url = "http://localhost:8000/api";
const api_url = "https://halloween-belle-grange.fr:9898/api";

export function get_inscriptions(filters_dict) {
    let filters = "";
    if (filters_dict) {
        Object.keys(filters_dict).map((key) => {
            filters += `${key}=${filters_dict[key]}&`;
            return null;
        });
    }

    return axios.get(`${api_url}/inscriptions/?${filters}`);
}

export function get_parameters() {
    return axios.get(`${api_url}/parameters/`);
}

export function set_parameters(parameters) {
    console.log(parameters);
    if (parameters?.id) {
        return axios.put(`${api_url}/parameters/${parameters.id}/`, { ...parameters });
    }

    return axios.post(`${api_url}/parameters/`, parameters);
}
export function save_inscription(inscription) {
    if (inscription?.id) {
        return axios.put(`${api_url}/inscriptions/${inscription.id}/`, { ...inscription });
    }

    return axios.post(`${api_url}/inscriptions/`, inscription);
}

export function delete_inscription(inscription_id) {
    return axios.delete(`${api_url}/inscriptions/${inscription_id}/`);
}
